import { useEffect } from 'react';
import LegalHero from '@/components/legal-ai/LegalHero';
import LegalProblem from '@/components/legal-ai/LegalProblem';
import LegalThesis from '@/components/legal-ai/LegalThesis';
import LegalWorkspace from '@/components/legal-ai/LegalWorkspace';
import LegalAccountability from '@/components/legal-ai/LegalAccountability';
import LegalControl from '@/components/legal-ai/LegalControl';
import LegalTeam from '@/components/legal-ai/LegalTeam';
import LegalPilot from '@/components/legal-ai/LegalPilot';
import LegalNotThis from '@/components/legal-ai/LegalNotThis';
import LegalFAQ from '@/components/legal-ai/LegalFAQ';
import LegalClose from '@/components/legal-ai/LegalClose';

const LegalAIPage = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Soundboard Matter \u2014 Controlled AI workspace for legal practice';

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute('content');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'A private, matter-aware workspace for solo and small legal practices. Organize the file, connect answers to sources, control what leaves, and keep a record of how AI-assisted work was reviewed.');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin + '/legal-ai';

    window.scrollTo(0, 0);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc) metaDesc.setAttribute('content', prevDesc);
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="legal-page" data-testid="legal-ai-page">
      <main>
        <LegalHero />
        <LegalProblem />
        <LegalThesis />
        <LegalWorkspace />
        <LegalAccountability />
        <LegalControl />
        <LegalTeam />
        <LegalPilot />
        <LegalNotThis />
        <LegalFAQ />
        <LegalClose />
      </main>
    </div>
  );
};

export default LegalAIPage;
